import React from 'react';
import './paymentRetryPane.module.scss';
import { observer, inject } from 'mobx-react';
import { SettingPane } from '../../molecules/mypage/page';
import { PaymentRetryPaneState } from './states/PaymentRetryPaneState';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable, makeObservable } from 'mobx';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { CreditCardInputV2 } from '../../molecules/payment/CardInput';
import { PaymentView } from './PaymentView';
import { FormError } from '../../../../commonv3/components/atoms/forms/vertical';
import { Heading } from '@sheinc/shelikes-design-system';

type Props = {
  homeState: HomePageState;
  match: {
    params: {
      code: string;
    };
  };
};

export const PaymentRetryPane = inject('homeState')(
  observer(
    class PaymentRetryPane extends React.Component<Props> {
      pageState = new PaymentRetryPaneState();
      cardFormVisible = false;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
          cardFormVisible: observable,
        });
      }

      async componentDidMount() {
        const { code } = this.props.match.params;
        this.pageState.init(code);
      }

      render() {
        const { payment: paymentResource, cardState, response, responseError } = this.pageState;

        const payment = paymentResource.get();
        const { number, yy, mm, cvc } = cardState.cardFormState.fields;
        return (
          <SettingPane activeMenu="payments" hasBackButton>
            <Heading size="XS">再支払いする内容</Heading>
            <div styleName="section-body">
              {paymentResource.loading ? <LoaderRow /> : <PaymentView payment={payment} showAction={false} />}
            </div>
            <Heading size="XS">使用するカード</Heading>
            <div styleName="section-body">
              <div styleName="payment-info">
                <CreditCardInputV2 cardState={cardState} />
                {[number, yy, mm, cvc].map((e, i) => (
                  <FormError key={i} state={e} />
                ))}
              </div>
              {responseError && <div styleName="error">{responseError.body}</div>}
            </div>
            <Button
              type={response && response.status == 'paid' ? 'success' : 'primary'}
              size="m"
              styleName="action-button"
              loading={this.pageState.submitState.submitting}
              onClick={() => this.pageState.submit(payment.code)}
            >
              {response && response.status == 'paid' ? '再支払いが完了しました' : '再支払いする'}
            </Button>
          </SettingPane>
        );
      }
    }
  )
);
